// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"595e055c9b4f14425cdb","293":"0f5f8d9545291e9b61d2","471":"6a66dfa1b46a01000eed"}[chunkId] + ".js";
};